import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-language-chooser' })
export class LanguageChooserComponent {	
	constructor(element: HTMLElement) {		
		element.addEventListener('change', () => this.handleChangeLanguageChooser(element));

	}

	private handleChangeLanguageChooser(select: Element) {
		let  target = '';
        const selectMenu = <HTMLSelectElement>select;
        const selectedIndex = selectMenu.selectedIndex;
        const selectedTag = <Element>selectMenu.options[selectedIndex];
        if (selectedTag != null) {
            target = selectedTag.getAttribute('value');
		}
		if(target && target != ""){
			window.location.href = target;
		}
    }
}